module.exports = __webpack_public_path__ + "png/bg-pattern-white-repeatable@2x.png";